import { ApiCaller } from '../../utils/api'
import { URLS } from '../../utils/url'
import { Message } from 'element-ui'
import router from '../../router'
const state = {
  current_clinic_child: {id: ''},
  storeBranchs: [],
  months_str: [],
  treatment_day_of_months: {},
  time_prices_chart: [],
  timeprice_colors_chart: [],
  age_customers_chart: [],
  age_colors_chart: [],
  therapists_chart: {},
  therapists_average_revanue: {},
  scale_gender_chart: []
}

const mutations = {
  SET_STORE_BRANCHS(state, payload) {
    state.storeBranchs = payload
  },
  SET_CURRENT_CLINIC_CHILD(state, payload) {
    state.current_clinic_child = payload
  },
  SET_MONTHS_STR(state, payload) {
    state.months_str = payload
  },
  SET_TREATMENT_DAY_OF_MONTHS(state, payload) {
    state.treatment_day_of_months = payload
  },
  SET_TIMEPRICES_CHART(state, payload) {
    state.time_prices_chart = payload
  },
  SET_TIMEPRICE_COLOR_CHART(state, payload) {
    state.timeprice_colors_chart = payload
  },
  SET_AGE_CUSTOMERS_CHART(state, payload) {
    state.age_customers_chart = payload
  },

  SET_AGE_COLOR_CHART(state, payload) {
    state.age_colors_chart = payload
  },
  SET_THERAPISTS_CHART(state, payload) {
    state.therapists_chart = payload
  },
  SET_THERAPISTS_AVERAGE_REVANUE(state, payload) {
    state.therapists_average_revanue = payload
  },
  SET_SCALE_GENDER_CHART(state, payload) {
    state.scale_gender_chart = payload
  }
}

const actions = {
  async fetchDataParentReportChart({ state, commit }, payload) {
    const response = await ApiCaller().get(URLS.DATA_PARENT_REPORT_CHARTS(), {
      params: payload
    })
    if (response.data.message == 'parentFalse') {
      router.push('/')
    }
    if (response) {
      commit('SET_STORE_BRANCHS', response.data.data_store_branch)
      commit('SET_CURRENT_CLINIC_CHILD', response.data.current_clinic)
      commit('SET_MONTHS_STR', response.data.months_str)
      commit('SET_TREATMENT_DAY_OF_MONTHS', response.data.treatment_day_of_months)
      commit('SET_TIMEPRICES_CHART', response.data.time_prices)
      commit('SET_TIMEPRICE_COLOR_CHART', response.data.timeprice_colors)
      commit('SET_AGE_CUSTOMERS_CHART', response.data.age_customers)
      commit('SET_AGE_COLOR_CHART', response.data.age_colors)
      commit('SET_THERAPISTS_CHART', response.data.therapists_chart)
      commit('SET_THERAPISTS_AVERAGE_REVANUE', response.data.therapists_average_revanue)
      commit('SET_SCALE_GENDER_CHART', response.data.scale_gender)
    }
  },
}

export default {
  namespaced: true,
  state, mutations, actions
}
